module.exports = __webpack_public_path__ + "img/example_label_all.8e7899ce.png";